import { Route } from '@angular/router';
import { RoutePath } from '@univacity/shared/types';
import { PayablesResolver } from './resolvers/payables.resolver';
import { QuoteResolver } from './resolvers/quote.resolver';

export const quoteRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    data: {
      fullWidth: true,
      transparent: true,
      transparentColor: 'white',
    },
    loadComponent: () =>
      import('./quote-home-page/quote-home-page.component').then(
        (c) => c.QuoteHomePageComponent
      ),
  },
  {
    path: RoutePath.tracking,
    loadComponent: () =>
      import('./quote-tracking-page/quote-tracking-page.component').then(
        (c) => c.QuoteTrackingPageComponent
      ),
  },
  {
    path: `${RoutePath.organisations.replace('/', '')}/:id`,
    resolve: {
      payables: PayablesResolver,
    },
    loadComponent: () =>
      import('./quote-checkout-page/quote-checkout-page.component').then(
        (c) => c.QuoteCheckoutPageComponent
      ),
  },
  {
    path: `:id/${RoutePath.checkout}/:quote`,
    loadComponent: () =>
      import('./quote-checkout-page/quote-checkout-page.component').then(
        (c) => c.QuoteCheckoutPageComponent
      ),
  },
  {
    path: RoutePath.quote,
    resolve: { quote: QuoteResolver },
    loadComponent: () =>
      import('./quote-detail-page/quote-detail-page.component').then(
        (c) => c.QuoteDetailPageComponent
      ),
  },
];
